import React from 'react';
import PropTypes from 'prop-types';
import { Breakdown as ReportBreakdownShape, Totals as ReportTotalsShape } from '../../shapes/report';
import ReportBreakdownItem from './report-breakdown-item';
import ReportBreakdownTotals from './report-breakdown-totals';
import Classes from './styles/index';

class ReportBreakdown extends React.Component {

  render() {
    const anyHardMeters = this.props.breakdown
      .some(breakdown => breakdown.hardMeter);
    return (
      <React.Fragment>
        <strong>Machine Summary</strong>
        <table className={Classes.reportBreakdownTable}>
          <thead>
          <tr>
            <td><em>Machine</em></td>
            <td><em>In</em></td>
            <td><em>Paid</em></td>
            <td><em>Net</em></td>
            <td><em>Tax</em></td>
          </tr>
          </thead>
          <tbody>
          {
            this.props.breakdown
              .map(
                (breakdown, index) => <ReportBreakdownItem breakdown={breakdown} key={index} />
              )
          }
          <ReportBreakdownTotals totals={this.props.totals} />
          {
            anyHardMeters ? (
              <tr>
                <td colSpan="5">* hard meters were used in one or more service reports</td>
              </tr>
            ) : null
          }
          </tbody>
        </table>
      </React.Fragment>
    )
  }

}

ReportBreakdown.propTypes = {
  breakdown: PropTypes.arrayOf(
    ReportBreakdownShape.isRequired
  ).isRequired,
  totals: ReportTotalsShape.isRequired
};

export default ReportBreakdown;


// WEBPACK FOOTER //
// ./src/views/report/report-breakdown.js